import { render, staticRenderFns } from "./TabButtonGroup.vue?vue&type=template&id=5fbb5b61&"
import script from "./TabButtonGroup.vue?vue&type=script&lang=ts&"
export * from "./TabButtonGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtnGroup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtnGroup})
